import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Guid } from '@fitscovery/common/types';
import { EmailTemplateCreateResponse } from '../models';

import { Environment } from '@fitscovery/common/environments';
import { APP_ENVIRONMENT } from '../environment-injection';
import { EmailTemplate, PMSEmailTemplate, PMSEmailTemplateCreateResponse } from '../models';

@Injectable()
export class ApiPMSEmailTemplateService {
    
  constructor(
    @Inject(APP_ENVIRONMENT) private env: Environment,
    private http: HttpClient
  ) { }
  
  createPMSEmailTemplate(pmsEmailTemplate: PMSEmailTemplate) : Observable<PMSEmailTemplateCreateResponse>{
    return <Observable<PMSEmailTemplateCreateResponse>>this.http.post(`${this.env.azureFunctionsApi.memberships}/partner-membership-subscription-email-template`, pmsEmailTemplate);
  }
  updatePMSEmailTemplate(pmsEmailTemplate: PMSEmailTemplate): Observable<PMSEmailTemplate> {
    return <Observable<PMSEmailTemplate>>this.http.put(`${this.env.azureFunctionsApi.memberships}/partner-membership-subscription-email-template/partner-membership-subscription/${pmsEmailTemplate.partnerMembershipSubscriptionId}`, pmsEmailTemplate);
  }
  deletePMSEmailTemplate(pmsEmailTemplate: PMSEmailTemplate): Observable<any> {
    return this.http.delete(`${this.env.azureFunctionsApi.memberships}/partner-membership-subscription-email-template/${pmsEmailTemplate.partnerMembershipSubscriptionId}`);
  }

  getPMSEmailTemplatesByPartnerId(partnerId: Guid): Observable<PMSEmailTemplate[]>{
    return <Observable<PMSEmailTemplate[]>>this.http.get(`${this.env.azureFunctionsApi.memberships}/partner-membership-subscription-email-template/partners/${partnerId}`);
  }
  getPMSEMailTemplate(partnerMembershipSubscriptionId: Guid): Observable<PMSEmailTemplate[]>{
    return <Observable<PMSEmailTemplate[]>>this.http.get(`${this.env.azureFunctionsApi.memberships}/partner-membership-subscription-email-template/partner-membership-subscription/${partnerMembershipSubscriptionId}`);
  }



  
  // **************************
  // Email Template methods 
  // **************************

  createEmailTemplate(emailTemplate: EmailTemplate): Observable<EmailTemplateCreateResponse> {
    return <Observable<EmailTemplateCreateResponse>>this.http.post(`${this.env.azureFunctionsApi.memberships}/email-templates`, emailTemplate);
  }
  updateEmailTemplate(emailTemplate: EmailTemplate): Observable<EmailTemplate> {
    return <Observable<EmailTemplate>>this.http.put(`${this.env.azureFunctionsApi.memberships}/email-templates/${emailTemplate.id}`, emailTemplate);
  }
  deleteEmailTemplate(emailTemplateId: Guid): Observable<any> {
    return this.http.delete(`${this.env.azureFunctionsApi.memberships}/email-templates/${emailTemplateId}`);
  }

  
  getEmailTemplateById(emailTemplateId: Guid): Observable<EmailTemplate[]> {
    return <Observable<EmailTemplate[]>>this.http.get(`${this.env.azureFunctionsApi.memberships}/email-templates/${emailTemplateId}`);
  }
  getEmailTemplatesByPartnerId(partnerId: Guid): Observable<EmailTemplate[]> {
    return <Observable<EmailTemplate[]>>this.http.get(`${this.env.azureFunctionsApi.memberships}/email-templates/partners/${partnerId}`);
  }
  

}
